import type { Subject } from "common/types";
import { extract, toAsyncResult } from "vsto/utils";
import { useVstoInterop } from "vsto/VstoInterop";

export function useMailboxItemSubject(): {
  getAsync: Subject["getAsync"];
  setAsync: Subject["setAsync"];
} {
  function getAsync(options, callback?) {
    const [, cb] = extract(options, callback);
    toAsyncResult(useVstoInterop().getCurrentItemSubject()).then(cb);
  }

  function setAsync(subject: string, options?, callback?) {
    const [, cb] = extract(options, callback);
    toAsyncResult(useVstoInterop().setCurrentItemSubject(subject)).then(cb);
  }

  return {
    getAsync,
    setAsync,
  };
}
